import { Modal, ModalContent, ModalOverlay } from "@chakra-ui/react";
import React from "react";

export const ModalComponent = ({ scrollBehavior = "inside", isOpen, finalRef, initialRef, onClose, id, ...props }) => {
	return (
		<Modal
			scrollBehavior={scrollBehavior}
			colorScheme={"brand"}
			isCentered
			autoFocus={false}
			initialFocusRef={initialRef}
			finalFocusRef={finalRef}
			isOpen={isOpen}
			onClose={onClose}
			{...props}
		>
			<ModalOverlay />
			<ModalContent>{props.children}</ModalContent>
		</Modal>
	);
};
